import React from 'react'
import { PhoneNumberLink } from '../../../components/PhoneNumberLink'
import { EmailLink } from '../../../components/EmailLink'
import { SeeYourOrderButton } from '../SeeYourOrderButton'
import { useParams } from 'react-router-dom'
import { Alert, Icon } from '@ztechapps/webui.util'
import { PageTitle } from '../../../components/PageTitle'

export const Page = () => {
  const { _id } = useParams()

  return (
    <div className="container">
      <PageTitle
        title="Order Confirmation"
        description="Your order has been successfully placed. Thank you for shopping with us!"
      />
      <div className="my-5 text-center">
        <Alert type="success">
          <div style={{ fontSize: '100px' }}>
            <Icon name="thumbs-up" />
          </div>

          <h1>
            Payment was successful!
            <br />
          </h1>
          <p>
            Thank you for shopping with us. If you need more inquiry please do not hesitate to call us{' '}
            <span>
              <PhoneNumberLink />
            </span>{' '}
            or email at{' '}
            <span>
              <EmailLink />
            </span>
          </p>
          <p>Check also your email for the receipt of the transaction.</p>
          <SeeYourOrderButton _id={_id} />
        </Alert>
      </div>
    </div>
  )
}

export default Page
